import { FilesService } from '../../files/FilesService'
import { OperationContext, OperationSpec } from './OperationContext'
import { RunnableOperation } from './RunnableOperation'

export class RunnableFileCopy extends RunnableOperation {
  constructor(userOpSpec: OperationSpec) {
    super(userOpSpec)
  }

  async execute(context: OperationContext): Promise<void> {
    this.setStatus('running')
    if (this.aborted) {
      throw new Error('Operazione interrotta')
    }

    try {
      console.log('copying file', this.userOpSpec.from)
      await FilesService.copyFile(this.userOpSpec).then(async (res) => {
        console.log('file copied', this.userOpSpec.from)
      })
    } catch (error) {
      console.error(error)
    }
  }

  abort(): void {
    // Implementazione dell'interruzione della copia
  }
}
